"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateModel = exports.makeDataObject = exports.makeModel = exports.ValidationError = void 0;
const class_transformer_1 = require("class-transformer");
const Validator = require("class-validator");
class ValidationError extends Error {
    constructor(errors) {
        super();
        this.errors = errors;
    }
}
exports.ValidationError = ValidationError;
const targetValidationErrorOff = {
    validator: {
        validationError: {
            target: false
        }
    }
};
const projectValues = (modelCtor, obj) => {
    return Object.getOwnPropertyNames(class_transformer_1.classToPlain(new modelCtor())).reduce((p, k) => {
        if (obj.hasOwnProperty(k) && obj[k] !== undefined) {
            p[k] = obj[k];
        }
        return p;
    }, {});
};
const makeModel = (modelCtor, obj, options = {}) => {
    const projectedObj = projectValues(modelCtor, obj);
    const model = class_transformer_1.plainToClass(modelCtor, projectedObj, options.transformer);
    const validationErrors = Validator.validateSync(model, options.validator);
    if (validationErrors.length) {
        throw new ValidationError(validationErrors);
    }
    return model;
};
exports.makeModel = makeModel;
const makeDataObject = (modelCtor, model, options = {}) => {
    const validationErrors = Validator.validateSync(model, options.validator);
    if (validationErrors.length) {
        throw new ValidationError(validationErrors);
    }
    const obj = class_transformer_1.classToPlain(model, options.transformer);
    return projectValues(modelCtor, obj);
};
exports.makeDataObject = makeDataObject;
const validateModel = (modelCtor, hideTargetObject) => {
    return (body) => {
        try {
            if (hideTargetObject) {
                return exports.makeModel(modelCtor, body, targetValidationErrorOff);
            }
            return exports.makeModel(modelCtor, body);
        }
        catch (e) {
            if (e instanceof ValidationError) {
                throw new Error(JSON.stringify(e.errors));
            }
            throw new Error("Could not validate model");
        }
    };
};
exports.validateModel = validateModel;
//# sourceMappingURL=convert.js.map